import session from "../../../../api/session";



export async function isUsernameExists(form) {
    return await session.get(`api/employees/?person_validation=${form.user.username}`)
}


export async function isCardNmberExists(form) {
    return await session.get(`api/device-identities/?card_number=${form.card.map((e) => e.cardNumber).join("")}`)
}